/**
 * en-GB messages added by Phase 3 task M5 (docs/PHASE-3-PLAN.md). Only that task edits this file.
 * Flat keys, `{name}` placeholders, merged into enGB by ./index.ts.
 */
export const m5EnGB = {
    // Home and settings entries
    'companion.p3.home.safety_title': 'Safety',
    'companion.p3.home.menu_lone_working': 'Lone working',
    'companion.p3.home.menu_roll_call': 'Evacuation roll call',
    'companion.p3.home.menu_panic': 'Panic button',
    'companion.p3.home.evacuation_banner': 'EVACUATION. Tap for instructions.',
    'companion.p3.home.drill_banner': 'FIRE DRILL. Tap for instructions.',
    'companion.p3.home.lone_ok': 'Lone working. Next check-in {time}.',
    'companion.p3.home.lone_attention': 'Lone working check-in needed.',
    'companion.p3.home.work_title': 'My work',
    'companion.p3.home.menu_parcels': 'My parcels',
    'companion.p3.home.menu_permits': 'My permits',
    'companion.p3.home.menu_documents': 'My documents',
    'companion.p3.home.menu_inductions': 'My inductions',
    'companion.p3.settings.title': 'Safety',
    'companion.p3.settings.urgent_note': 'Evacuation and lone-working alerts use the Urgent alerts channel. If they are silent, check that Urgent alerts is allowed to make a sound in your phone settings.',
    'companion.p3.settings.pending': '{count} safety actions are waiting to be sent.',
    'companion.p3.settings.none_pending': 'Nothing is waiting to be sent.',
    // Not sent
    'companion.p3.not_sent.title': 'Not sent',
    'companion.p3.not_sent.body': 'The server refused these safety actions, so they were NOT sent. Please tell your site contact or try again.',
    'companion.p3.not_sent.item_im_safe': "I'm safe at {time}",
    'companion.p3.not_sent.item_evac_mark': 'Roll call mark at {time}',
    'companion.p3.not_sent.item_lone_start': 'Start lone working at {time}',
    'companion.p3.not_sent.item_lone_checkin': 'Lone working check-in at {time}',
    'companion.p3.not_sent.item_lone_end': 'End lone working at {time}',
    'companion.p3.not_sent.item_lone_panic': 'PANIC alert at {time}',
    'companion.p3.not_sent.seen': 'I have seen this',
    'companion.p3.pending': '{count} waiting to be sent. They will go as soon as there is a connection.',
    'companion.p3.offline': 'No connection.',
    // Evacuation alert and I'm safe
    'companion.p3.evac.title_real': 'EVACUATION',
    'companion.p3.evac.title_drill': 'FIRE DRILL',
    'companion.p3.evac.leave': 'Leave the building now by the nearest safe exit and go to a muster point.',
    'companion.p3.evac.drill_note': 'This is a drill. Please act as if it is real.',
    'companion.p3.evac.points': 'Muster points',
    'companion.p3.evac.choose_point': 'Where are you?',
    'companion.p3.evac.no_directions': 'No directions given.',
    'companion.p3.evac.im_safe': "I'm safe",
    'companion.p3.evac.im_safe_hint': 'Tell the marshals you are out of the building and safe.',
    'companion.p3.evac.im_safe_sent': 'Thank you. You are marked as safe.',
    'companion.p3.evac.im_safe_queued': 'Saved on this phone. It will be sent as soon as there is a connection.',
    'companion.p3.evac.im_safe_failed': 'That could not be saved. Please tell a marshal you are safe.',
    'companion.p3.evac.no_location': 'Your location is not shared when you tap this button.',
    'companion.p3.evac.roll_call_button': 'Open the roll call',
    'companion.p3.evac.menu_button': 'Back to the app menu',
    'companion.p3.evac.none': 'There is no evacuation at the moment.',
    'companion.p3.evac.since': 'Started at {time}',
    // Marshal roll call
    'companion.p3.roll.title': 'Evacuation roll call',
    'companion.p3.roll.not_marshal': 'You are not set up as a marshal for this site.',
    'companion.p3.roll.none_active': 'There is no evacuation at the moment.',
    'companion.p3.roll.counts': '{unaccounted} not accounted for, {safe} safe, {missing} missing, {offSite} off site',
    'companion.p3.roll.total': '{total} people',
    'companion.p3.roll.tab_all': 'Everyone',
    'companion.p3.roll.tab_no_point': 'No point',
    'companion.p3.roll.search': 'Search by name',
    'companion.p3.roll.status_unaccounted': 'Not accounted for',
    'companion.p3.roll.status_safe': 'Safe',
    'companion.p3.roll.status_missing': 'Missing',
    'companion.p3.roll.status_off_site': 'Off site',
    'companion.p3.roll.mark_safe': 'Safe',
    'companion.p3.roll.mark_missing': 'Missing',
    'companion.p3.roll.mark_off_site': 'Off site',
    'companion.p3.roll.check': 'Check',
    'companion.p3.roll.check_help': 'Different people marked this person differently. Please check with them.',
    'companion.p3.roll.visitor': 'Visitor',
    'companion.p3.roll.host': 'Host: {name}',
    'companion.p3.roll.permits': '{count} open permits',
    'companion.p3.roll.empty': 'Nobody matches.',
    'companion.p3.roll.mark_failed': 'That mark could not be saved. Please try again.',
    'companion.p3.roll.cached': 'No connection. Showing the list saved on this phone at {time}. Your marks are kept and will be sent when you are back online.',
    'companion.p3.roll.start_title': 'Start an evacuation',
    'companion.p3.roll.start_drill': 'Start a drill',
    'companion.p3.roll.start_real': 'Start a real evacuation',
    'companion.p3.roll.start_confirm_real': 'Start a real evacuation at {site}? Everyone at the site will be alerted.',
    'companion.p3.roll.start_confirm_drill': 'Start a drill at {site}? Everyone at the site will be alerted.',
    'companion.p3.roll.start_yes': 'Start',
    'companion.p3.roll.start_site': 'Site',
    'companion.p3.roll.end': 'End the evacuation',
    'companion.p3.roll.end_confirm': 'End the evacuation for everyone? The roll call is then closed and the report is built.',
    'companion.p3.roll.end_yes': 'End it',
    'companion.p3.roll.end_failed': 'The evacuation could not be ended. Check your connection and try again.',
    // Lone working
    'companion.p3.lone.title': 'Lone working',
    'companion.p3.lone.not_applicable': 'Lone working does not apply to you.',
    'companion.p3.lone.no_session': 'You are not lone working at the moment.',
    'companion.p3.lone.state_ok': 'All is well',
    'companion.p3.lone.state_prompted': 'Please check in now',
    'companion.p3.lone.state_second_prompt': 'Please check in now. Your contacts will be told soon.',
    'companion.p3.lone.state_escalated': 'Your contacts have been told you have not checked in',
    'companion.p3.lone.state_panic': 'Panic alert sent',
    'companion.p3.lone.state_ended': 'Lone working ended',
    'companion.p3.lone.at_site': 'At {site}, since {time}',
    'companion.p3.lone.next_due': 'Next check-in by {time}',
    'companion.p3.lone.last': 'Last check-in {time}',
    'companion.p3.lone.planned_end': 'Planned to finish at {time}',
    'companion.p3.lone.im_ok': "I'm OK",
    'companion.p3.lone.checkin_saved': 'Thanks, checked in.',
    'companion.p3.lone.checkin_failed': 'The check-in could not be saved. Please try again.',
    'companion.p3.lone.no_location': 'Your location is not shared when you check in.',
    'companion.p3.lone.no_contacts': 'No contact can be reached. Please tell your manager.',
    'companion.p3.lone.contacts': 'Your contacts',
    'companion.p3.lone.contacts_note': 'Contacts are set up in the portal.',
    'companion.p3.lone.start_title': 'Start lone working',
    'companion.p3.lone.start_button': 'Start lone working',
    'companion.p3.lone.start_saved': 'Lone working started.',
    'companion.p3.lone.start_failed': 'It could not be started. Please try again.',
    'companion.p3.lone.finish_in': 'Finish in',
    'companion.p3.lone.finish_open': 'No set time',
    'companion.p3.lone.finish_hours': '{hours} h',
    'companion.p3.lone.end_button': 'I have finished lone working',
    'companion.p3.lone.end_confirm': 'End lone working? You will no longer be asked to check in.',
    'companion.p3.lone.end_yes': 'End it',
    'companion.p3.lone.end_failed': 'It could not be ended. Please try again.',
    'companion.p3.lone.panic_open': 'Panic button',
    'companion.p3.lone.reminders': "Reminders arrive as urgent notifications. You can tap I'm OK in the notification.",
    // Panic
    'companion.p3.panic.title': 'Panic',
    'companion.p3.panic.intro': 'Use this if you are in danger or need urgent help. Your contacts and the site team are alerted at once.',
    'companion.p3.panic.hold': 'Hold for 2 seconds to send',
    'companion.p3.panic.holding': 'Keep holding...',
    'companion.p3.panic.hold_hint': 'Press and hold to send a panic alert',
    'companion.p3.panic.tap_hint': 'Press and hold the button. A quick tap does nothing.',
    'companion.p3.panic.confirm_title': 'Send a panic alert?',
    'companion.p3.panic.confirm_body': 'Your contacts and the site team will be alerted at once.',
    'companion.p3.panic.confirm_yes': 'Send alert',
    'companion.p3.panic.sending': 'Sending... please wait',
    'companion.p3.panic.sent': 'Alert sent. Help has been told. Stay where you are if it is safe.',
    'companion.p3.panic.fallback': 'NOT confirmed yet. Your alert is saved and will be sent when there is a signal. Please call someone now.',
    'companion.p3.panic.failed': 'The alert could not be sent. Please call someone now.',
    'companion.p3.panic.call': 'Call {name}',
    'companion.p3.panic.text': 'Text {name}',
    'companion.p3.panic.call_999': 'Call 999',
    'companion.p3.panic.sms_body': 'I need help. I sent a panic alert from the CloudSign app but it may not have arrived.',
    'companion.p3.panic.no_location': 'Your location is not shared with the alert.',
    'companion.p3.panic.again': 'Send again',
};
//# sourceMappingURL=m5.js.map